module.exports = __webpack_public_path__ + "static/media/animal-lion1.75eda1b9.aac";